import { useCallback, useEffect, useState } from 'react';
import { ftblApi } from 'shared/api/ftblApi';
import { FtblPrediction, FtblPredictionsResponse } from 'shared/pages/designer/components/ProfilePredictions/types';
import { AppTester } from 'supporting';

const PREDICTIONS_PAGE_SIZE = 10;

const getHasMore = (paging?: FtblPredictionsResponse['paging']) => {
  if (!paging) return false;

  return paging.page < paging.pages;
};

export const useFtblProfilePredictions = (accountId?: string) => {
  const [predictions, setPredictions] = useState<FtblPrediction[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    if (!AppTester.isFtbl() || !accountId) {
      setPredictions([]);
      setHasMore(false);
      setPage(1);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setPage(1);

    ftblApi()
      .getPredictions({ accountId, page: 1, limit: PREDICTIONS_PAGE_SIZE })
      .then((data: FtblPredictionsResponse) => {
        setPredictions(data?.data ?? []);
        setHasMore(getHasMore(data?.paging));
        setPage(data?.paging?.page ?? 1);
      })
      .catch(() => {
        setPredictions([]);
        setHasMore(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [accountId]);

  const loadMore = useCallback(() => {
    if (!AppTester.isFtbl() || !accountId || !hasMore || isLoadingMore || isLoading) return;

    const nextPage = page + 1;

    setIsLoadingMore(true);

    ftblApi()
      .getPredictions({ accountId, page: nextPage, limit: PREDICTIONS_PAGE_SIZE })
      .then((data: FtblPredictionsResponse) => {
        setPredictions((prev) => [...prev, ...(data?.data ?? [])]);
        setHasMore(getHasMore(data?.paging));
        setPage(data?.paging?.page ?? nextPage);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoadingMore(false);
      });
  }, [accountId, hasMore, isLoading, isLoadingMore, page]);

  return {
    predictions,
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
  };
};
import { useCallback, useEffect, useState } from 'react';
import { ftblApi } from 'shared/api/ftblApi';
import { FtblPrediction, FtblPredictionsResponse } from 'shared/pages/designer/components/ProfilePredictions/types';
import { AppTester } from 'supporting';

const PREDICTIONS_PAGE_SIZE = 10;

const getHasMore = (paging?: FtblPredictionsResponse['paging']) => {
  if (!paging) return false;

  return paging.page < paging.pages;
};

export const useFtblProfilePredictions = (accountId?: string) => {
  const [predictions, setPredictions] = useState<FtblPrediction[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => {
    if (!AppTester.isFtbl() || !accountId) {
      setPredictions([]);
      setHasMore(false);
      setPage(1);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setPage(1);

    ftblApi()
      .getPredictions({ accountId, page: 1, limit: PREDICTIONS_PAGE_SIZE })
      .then((data: FtblPredictionsResponse) => {
        setPredictions(data?.data ?? []);
        setHasMore(getHasMore(data?.paging));
        setPage(data?.paging?.page ?? 1);
      })
      .catch(() => {
        setPredictions([]);
        setHasMore(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [accountId]);

  const loadMore = useCallback(() => {
    if (!AppTester.isFtbl() || !accountId || !hasMore || isLoadingMore || isLoading) return;

    const nextPage = page + 1;

    setIsLoadingMore(true);

    ftblApi()
      .getPredictions({ accountId, page: nextPage, limit: PREDICTIONS_PAGE_SIZE })
      .then((data: FtblPredictionsResponse) => {
        setPredictions((prev) => [...prev, ...(data?.data ?? [])]);
        setHasMore(getHasMore(data?.paging));
        setPage(data?.paging?.page ?? nextPage);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoadingMore(false);
      });
  }, [accountId, hasMore, isLoading, isLoadingMore, page]);

  return {
    predictions,
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
  };
};
